export function PostRequest(path, params) {   
  
  const parameters = Object.keys(params).map((key) => {
    // HTML encode dell'escaping
    return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
  }).join('&');

  const options = {
    method: 'POST',           
    headers: {
      "Access-Control-Request-Headers": "*",
      "Access-Control-Request-Method": "*",
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"   
    },
    body: parameters
  };  

  return new Promise((resolve, reject) =>{    
    fetch(path, options)
    .then((response) => response.json())
    .then((res) => {      
      resolve(res);
    })    
    .catch((error) => {      
      reject(error);
    });    
  });
 
}


// WEBPACK FOOTER //
// ./src/api/PostRequest.js